import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { createReducer } from '@lib/plugin-redux-core';
import { initialFileStorageState } from './file-storage.state';
import { fileStorageHandlers } from './file-storage.handler';
export var fileStorageReducer = createReducer(initialFileStorageState, _toConsumableArray(fileStorageHandlers));